<template>
  <div class="input-group" :class="{
    'disabled': disabled
  }">  
    <input type="checkbox"
           class="checkbox option-input"
           v-model="model"
           :id="id"
           :disabled="disabled">

    <label class="d-flex m-0" :for="id">
      <span 
        :class="{'bg-secondary-10 border-color--primary-5': hasError}"
        class="mt-1 bg-white">
        <em v-if="model" class="ic-check"></em>
      </span>
      {{ text }}
    </label>
  </div>
</template>

<script>
export default {
  name: "CustomCheckbox",
  props: {
    text: {
      type: String,
      default: () => null
    },
    value: {
      type: Boolean,
      default: () => null
    },
    disabled: {
      type: Boolean,
      default: () => null
    },
    hasError: {
      type: [Boolean, String],
      default: () => null
    }
  },
  data() {
    return {
      model: this.value,
      id: Math.random().toString(36)
    };
  },
  watch: {
    model(val){
      this.$emit("input", val)
    },
    value(val){
      this.model = val;
    }
  }
};
</script>

<style scoped>
.input-group .option-input {
	display: none;
}
.input-group .option-input + label span {
	display: inline-block;
	width: 20px;
	height: 20px;
	margin: -2px 10px 0 0;
	vertical-align: middle;
	border: 1px solid #E2E2E2;
    border-radius: 4px;
	cursor: pointer;
}
.input-group .option-input:checked + label span .ic-check {
	background: url('./icon-check-solid.svg');
    background-size: cover;
    display: flex;
	width: 18px;
    height: 14px;
    margin: 2px auto;
}

.input-group.disabled .option-input:checked + label span .ic-check {
  background: url('./icon-check-solid-disabled.svg');
}
</style>